import React from "react";
import _ from "lodash";
import Select from "react-select";
import { NetworkAPI } from "apis";
import LoadingUI from "components/common/LoadingUI";

let CACHE_ITEMS = {};

class GAMMobileApplicationSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      options: [],
      selectedValue: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const { selectedItems, networkId } = this.props;

    if (!networkId) {
      return;
    }

    const cachedItems = CACHE_ITEMS[networkId];
    let items = [];
    if (cachedItems && cachedItems.length > 0) {
      items = cachedItems;
    } else {
      this.setState({ isLoading: true });
      items = await NetworkAPI.getNetworkMobileApplications({ networkId });
      CACHE_ITEMS[networkId] = items;
      if (!items) {
        throw new Error("Failed to find mobile applications");
      }
    }

    const options = _.filter(items, (item) => {
      return (
        item.approvalStatus === "READY" ||
        selectedItems.includes(item.applicationId)
      );
    }).map((item) => ({
      value: item.applicationId,
      label: item.applicationName,
      isDisabled: item.approvalStatus !== "READY",
    }));

    this.setState({
      isLoading: false,
      options,
      selectedValue: _.filter(options, (option) => {
        return _.indexOf(selectedItems, option.value) !== -1;
      }),
    });
  }

  handleChange(options) {
    this.setState({
      selectedValue: options,
    });

    this.props.handleChanged(_.map(options, "value"));
  }

  render() {
    const { isReadonly = false } = this.props;
    const { options, selectedValue, isLoading } = this.state;

    return (
      <>
        {isLoading && isReadonly && <LoadingUI iconOnly={true} />}
        {isReadonly ? (
          selectedValue.map((item, i) => {
            return (
              <div
                key={i}
                className="mb-1 mr-1 inline-block bg-gray-200 px-1 text-gray-800"
              >
                {`${item.value} ${item.label}`}
              </div>
            );
          })
        ) : (
          <Select
            defaultValue={selectedValue}
            value={selectedValue}
            onChange={this.handleChange}
            options={options}
            isSearchable={true}
            isMulti={true}
            isLoading={isLoading}
            isDisabled={isReadonly}
          />
        )}
      </>
    );
  }
}

export default GAMMobileApplicationSelector;
